import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";

/** Visual breadcrumb trail (pair with SeoMeta breadcrumbJsonLd for SEO). */
export default function Breadcrumbs({ items, testid = "breadcrumbs" }) {
  return (
    <nav aria-label="Breadcrumb" data-testid={testid}
      className="flex flex-wrap items-center gap-1 font-mono-tech text-[10px] tracking-[0.22em] uppercase text-[color:var(--np-muted,#3A3830)]">
      {items.map((it, i) => (
        <span key={i} className="inline-flex items-center gap-1">
          {i > 0 && <CaretRight size={9} weight="bold" className="opacity-50" />}
          {it.to ? (
            <Link to={it.to} className="hover:text-[#1B4332] hover:underline underline-offset-2">{it.label}</Link>
          ) : (
            <span className="text-[#1B4332]">{it.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
